const tours = [
  {
    id: "1",
    title: "Paris, Getaway",
    city: "Paris",
    address: "Champ de Mars, 7th Arrondissement, Paris",
    distance: 4900,
    photo: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=80",
    price: 700,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A classic Paris itinerary covering the Eiffel Tower, Seine riverside walks, and the city's historic districts.",
    featured: true,
  },
  {
    id: "2",
    title: "African Safari, Nairobi",
    city: "Nairobi",
    address: "Maasai Mara National Reserve, Narok County",
    distance: 4450,
    photo: "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1600&q=80",
    price: 500,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "Guided game drives across the Maasai Mara, with scheduled departures and licensed local guides.",
    featured: false,
  },
  {
    id: "3",
    title: "Tokyo Adventure, Tokyo",
    city: "Tokyo",
    address: "Shinjuku, Tokyo",
    distance: 12300,
    photo: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=1600&q=80",
    price: 800,
    avgRating: 4.7,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A city programme covering Shibuya, Shinjuku, and Tokyo's food and culture districts, with rail passes arranged.",
    featured: false,
  },
  {
    id: "4",
    title: "New York City Tour",
    city: "New York",
    address: "Manhattan, New York City",
    distance: 8650,
    photo: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?auto=format&fit=crop&w=1600&q=80",
    price: 300,
    avgRating: 4.6,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A structured Manhattan itinerary including Midtown landmarks, museums, and borough viewpoints.",
    featured: true,
  },
  {
    id: "5",
    title: "Santorini Escape",
    city: "Santorini",
    address: "Oia, Thira, Santorini",
    distance: 6000,
    photo: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=1600&q=80",
    price: 440,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "An Aegean island stay based in Oia and Fira, with caldera views, ferry transfers, and coastal walks.",
    featured: true,
  },
  {
    id: "6",
    title: "Dubai Luxury Tour",
    city: "Dubai",
    address: "Downtown Dubai, United Arab Emirates",
    distance: 6100,
    photo: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=80",
    price: 600,
    avgRating: 4.7,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A Dubai city programme covering Burj Khalifa, the Dubai Marina, and a desert safari excursion.",
    featured: false,
  },
  {
    id: "7",
    title: "Island Retreat, Indonesia",
    city: "Bali",
    address: "Ubud, Gianyar Regency, Bali",
    distance: 12600,
    photo: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1600&q=80",
    price: 210,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A Bali retreat combining Ubud's rice terraces and temples with coastal days in the south of the island.",
    featured: true,
  },
  {
    id: "8",
    title: "Alps Expedition, Zurich",
    city: "Zurich",
    address: "Zurich & Swiss Alps Region, Switzerland",
    distance: 4800,
    photo: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1600&q=80",
    price: 370,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "An alpine itinerary from Zurich into the Swiss high country, with rail connections and guided hikes.",
    featured: false,
  },
  {
    id: "9",
    title: "London City Escape",
    city: "London",
    address: "Westminster, London",
    distance: 5000,
    photo: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1600&q=80",
    price: 750,
    avgRating: 4.7,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A London programme covering Westminster, the Thames South Bank, and the city's museums and markets.",
    featured: true,
  },
  {
    id: "10",
    title: "Maldives Overwater Retreat",
    city: "Malé",
    address: "Malé Atoll, Maldives",
    distance: 8300,
    photo: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=1600&q=80",
    price: 900,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "An overwater villa stay in the Malé Atoll with seaplane transfers and scheduled reef excursions.",
    featured: true,
  },
  {
    id: "11",
    title: "Rome Heritage Tour",
    city: "Rome",
    address: "Piazza del Colosseo, Rome",
    distance: 4050,
    photo: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=1600&q=80",
    price: 650,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A guided heritage itinerary covering the Colosseum, Roman Forum, and Vatican City with timed entry tickets.",
    featured: false,
  },
  {
    id: "12",
    title: "Istanbul Heritage",
    city: "Istanbul",
    address: "Sultanahmet, Istanbul",
    distance: 5500,
    photo: "https://images.unsplash.com/photo-1560148697-235d7949277d?auto=format&fit=crop&w=1600&q=80",
    price: 550,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A programme spanning the Hagia Sophia, Topkapi Palace, and the Grand Bazaar across the European and Asian sides of the Bosphorus.",
    featured: true,
  },
  {
    id: "13",
    title: "Marrakech Medina",
    city: "Marrakech",
    address: "Jemaa el-Fnaa, Marrakech",
    distance: 3700,
    photo: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=80",
    price: 480,
    avgRating: 4.7,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A stay in a traditional riad within the medina, with excursions to the Atlas Mountains and the Sahara fringe.",
    featured: false,
  },
  {
    id: "14",
    title: "Rio de Janeiro Highlights",
    city: "Rio de Janeiro",
    address: "Tijuca National Park, Rio de Janeiro",
    distance: 6900,
    photo: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=1600&q=80",
    price: 720,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "An itinerary featuring Christ the Redeemer, Sugarloaf Mountain, and the iconic beaches of Copacabana and Ipanema.",
    featured: true,
  },
  {
    id: "15",
    title: "Sydney Harbour Tour",
    city: "Sydney",
    address: "Circular Quay, Sydney",
    distance: 17500,
    photo: "https://images.unsplash.com/photo-1528072164453-f4e8ef0d475a?auto=format&fit=crop&w=1600&q=80",
    price: 850,
    avgRating: 4.7,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A harbour-focused programme including the Sydney Opera House, the Harbour Bridge, and coastal walks to Bondi.",
    featured: false,
  },
  {
    id: "16",
    title: "Barcelona Cultural Stay",
    city: "Barcelona",
    address: "La Sagrada Família, Barcelona",
    distance: 4500,
    photo: "https://images.unsplash.com/photo-1583422409516-2895a77efded?auto=format&fit=crop&w=1600&q=80",
    price: 680,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "Gaudí landmarks, Gothic Quarter walks, and Catalan cuisine across a structured city programme.",
    featured: true,
  },
  {
    id: "17",
    title: "Cape Town Discovery",
    city: "Cape Town",
    address: "Table Mountain, Cape Town",
    distance: 5000,
    photo: "https://images.unsplash.com/photo-1746876269545-c23ecff55722?auto=format&fit=crop&w=1600&q=80",
    price: 580,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "Table Mountain ascents, Cape Point drives, and the Winelands of Stellenbosch and Franschhoek.",
    featured: true,
  },
  {
    id: "18",
    title: "Kyoto Traditional Tour",
    city: "Kyoto",
    address: "Fushimi Ward, Kyoto",
    distance: 13000,
    photo: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1600&q=80",
    price: 820,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A heritage itinerary through Fushimi Inari, Arashiyama bamboo grove, and Kyoto's geisha district of Gion.",
    featured: false,
  },
  {
    id: "19",
    title: "Petra & Jordan Wonders",
    city: "Petra",
    address: "Wadi Musa, Petra",
    distance: 4500,
    photo: "https://images.unsplash.com/photo-1779891425286-fa1bfb110925?auto=format&fit=crop&w=1600&q=80",
    price: 620,
    avgRating: 4.8,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "A guided visit to the Al-Khazneh Treasury, the Siq canyon, and a desert stay in Wadi Rum.",
    featured: true,
  },
  {
    id: "20",
    title: "Iceland Natural Wonders",
    city: "Reykjavik",
    address: "Golden Circle, Iceland",
    distance: 7200,
    photo: "https://images.unsplash.com/photo-1504829857797-ddff29c27927?auto=format&fit=crop&w=1600&q=80",
    price: 780,
    avgRating: 4.9,
    reviewTitle: "Traveler Reviews",
    reviews: [],
    maxGroupSize: 20,
    desc: "The Golden Circle route, blue lagoon visits, and northern lights excursions from Reykjavik.",
    featured: false,
  },
];

export default tours;